export const SET_DIALOG_FLAG = 'SET_DIALOG_FLAG';

export function setDialogFlag(key, value) {
    return { type: SET_DIALOG_FLAG, key, value };
}
